// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__CqYaZ","label":"Labeled_label__3y13-","divider":"Labeled_divider__2_6NS"};